var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-x grid-margin-x pega-mt-05" }, [
    _c(
      "div",
      { staticClass: "margin-left-1", attrs: { "data-test": "label" } },
      [_c("span", [_vm._v(_vm._s(_vm.label))])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "margin-left-3" },
      [
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "label",
            { key: i, staticClass: "pega-badge-radio pega-mr-5" },
            [
              _c("input", {
                attrs: { "data-test": "radio-value-" + i, type: "radio" },
                domProps: {
                  value: option.id,
                  checked: _vm.value === option.id,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("input", $event.target._value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "pega-badge-radio-text pega-badge-radio-check-mark",
                  attrs: { "data-test": "radio-label-" + i },
                },
                [_vm._v(_vm._s(option.name))]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _vm._t("error"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }